import {
  Button,
  IconButton,
  ListItemButton,
  ListItemButtonProps,
  ListItemSecondaryAction,
  ListItemText,
  Skeleton
} from '@mui/material'
import { Asset } from '../types'
import { useTranslation } from 'react-i18next'
import AssetCompanyEditButton from './AssetCompanyEditButton'

export interface AssetCompanyListItemButtonProps extends Omit<ListItemButtonProps, 'children'> {
  asset: Asset
  editable?: boolean
  afterUpdate?: (asset: Asset) => void
}

export default function AssetCompanyListItemButton({
  asset,
  editable = false,
  afterUpdate,
  ...props
}: AssetCompanyListItemButtonProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('asset')

  return (
    <ListItemButton {...props}>
      <ListItemText
        primary={
          asset.company ? (
            asset.company.name
          ) : asset.companyId === null ? (
            t('noCompany')
          ) : (
            <Skeleton variant="text" width={100} height={20} />
          )
        }
        primaryTypographyProps={{
          color: asset.companyId === null ? 'text.disabled' : 'inherit'
        }}
        secondary={t('company')}
      />

      {editable && (
        <ListItemSecondaryAction>
          <AssetCompanyEditButton
            asset={asset}
            component={asset.companyId === null ? Button : IconButton}
            variant="outlined"
            afterUpdate={afterUpdate}
          />
        </ListItemSecondaryAction>
      )}
    </ListItemButton>
  )
}
